import { render, staticRenderFns } from "./SmallMark.vue?vue&type=template&id=3811003b&scoped=true&"
import script from "./SmallMark.vue?vue&type=script&lang=js&"
export * from "./SmallMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3811003b",
  null
  
)

export default component.exports